import React, {
  ReactNode,
  SyntheticEvent,
  useEffect,
  useRef,
  useState,
} from "react";
import Box from "@mui/material/Box";
import Draggable from "react-draggable";
import UndoIcon from "@mui/icons-material/Undo";
import RedoIcon from "@mui/icons-material/Redo";
import SaveIcon from "@mui/icons-material/Save";
import PreviewIcon from "@mui/icons-material/Preview";
import PhotoIcon from "@mui/icons-material/Photo";
import VideoCameraBackIcon from "@mui/icons-material/VideoCameraBack";
import DirectionsWalkIcon from "@mui/icons-material/DirectionsWalk";
import ViewInArIcon from "@mui/icons-material/ViewInAr";
import CropFreeIcon from "@mui/icons-material/CropFree";
import ThreeDRotationIcon from "@mui/icons-material/ThreeDRotation";
import PhotoSizeSelectSmallOutlinedIcon from "@mui/icons-material/PhotoSizeSelectSmallOutlined";
import HighlightOffIcon from "@mui/icons-material/HighlightOff";
import MenuIcon from "@mui/icons-material/Menu";
import DragIndicatorIcon from "@mui/icons-material/DragIndicator";
import {
  Divider,
  ListItemIcon,
  ListItemText,
  MenuItem,
  MenuList,
  Stack,
} from "@mui/material";
import { Project, actions as builderActions } from "@/store/builderSlice";
import BuilderSelect from "@/store/builderStoreSelector";
import { saveProject as saveProjectThunk } from "@/store/builder/thunks/projectSaveThunk";
import {
  BUILDER_FAILED,
  BUILDER_IN_PROGRESS,
  BUILDER_SUCCESS,
  DimensionalViewType,
  ProductPlacementType,
  RoomViewType,
  SurfaceType,
} from "@/utils/builder/builderConstants";
import ClientComponent from "./client_component";
import { useDispatch } from "react-redux";
import TopIcon from "@/assets/images/top_icon.png";
import RecenterIcon from "@/assets/images/recenter_icon.png";
import DimensionIcon from "@/assets/images/dimension_icon.png";

function ToolsBar() {
  const dispatch = useDispatch();
  const [value, setValue] = useState<number | undefined>(undefined);
  const [panelPosition, setPanelPosition] = useState({
    x: window.innerWidth - 725,
    y: window.innerHeight - 60,
  });
  const isPreviewMode: boolean = BuilderSelect.ui().viewMode === "preview";
  const isDimensionsEnabled: boolean = BuilderSelect.ui().enableDimensions;
  const currentRoomId: string = BuilderSelect.activeSelection().roomId;
  const undoStackLength = BuilderSelect.undoStack().length;
  const undoStackPointer = BuilderSelect.undoStackPointer();
  const roomView: string = BuilderSelect.ui().roomView;
  const isCustomRoomFlow: boolean = BuilderSelect.ui().isCustomRoomFlow;
  const dimensionalView: string = BuilderSelect.ui().dimensionalView;
  const layoutBuilderMode: string = BuilderSelect.ui().layoutBuilderMode;
  //const roomLayoutSaveStatus = BuilderSelect.twoDRoomLayout().saveStatus;
  const canUndo = undoStackPointer > -1;
  const canRedo = undoStackPointer < undoStackLength - 1;
  const projectSaveInit = useRef(false);

  const saveProject = () => {
    // if (isCustomRoomFlow) {
    //   projectSaveInit.current = true;
    //   dispatch(saveRoomLayout({}) as any);
    // } else {
    dispatch(saveProjectThunk({}) as any);
    //}

    dispatch(
      builderActions.updateSaveStatus({ saveStatus: BUILDER_IN_PROGRESS })
    );
  };

  // useEffect(() => {
  //   if (projectSaveInit.current) {
  //     projectSaveInit.current = false;
  //     if (roomLayoutSaveStatus === BUILDER_SUCCESS)
  //       dispatch(saveProjectThunk({}) as any);
  //     if (roomLayoutSaveStatus === BUILDER_FAILED)
  //       dispatch(builderActions.updateSaveStatus({ saveStatus: BUILDER_FAILED }));
  //   }
  // }, [roomLayoutSaveStatus]);

  const undo = () => {
    dispatch(builderActions.undo({}));
  };

  const redo = () => {
    dispatch(builderActions.redo({}));
  };

  const togglePreviewMode = () => {
    dispatch(
      builderActions.setViewMode({
        viewMode: isPreviewMode ? "edit" : "preview",
      })
    );
  };
  const toggleDimensionsMode = () => {
    dispatch(
      builderActions.setDimensionsMode({
        enableDimensions: !isDimensionsEnabled,
      })
    );
  };

  const handleDragStop = (event: any, { x, y }: { x: number; y: number }) => {
    setPanelPosition({ x, y });
  };

  const changeRoomView = (newRoomView: string) => {
    dispatch(
      builderActions.updateRoomView({
        roomView: newRoomView,
      })
    );
  };

  const changeDimensionalView = (newDimensionalView: string) => {
    dispatch(
      builderActions.updateDimensionalView({
        dimensionalView: newDimensionalView,
      })
    );
    newDimensionalView === DimensionalViewType.TWO_D
      ? changeRoomView(RoomViewType.top)
      : changeRoomView(RoomViewType.default);
  };

  const captureImage = () => {
    alert("Available soon....");
  };

  const captureVideo = () => {
    alert("Available soon....");
  };

  if (!currentRoomId && !isCustomRoomFlow) return <></>;

  return (
    <>
      <Box
        component="div"
        onClick={() => redo()}
        sx={{
          width: "40px",
          position: "fixed",
          top: "85px",
          right: "20px",
          zIndex: "20",
          cursor: "pointer",
        }}
      >
        <Stack>
          <ListItemIcon
            sx={{
              background: "rgba(0,0,0,0.5)",
              minWidth: "40px",
              borderRadius: "100%",
              width: "40px",
              height: "40px",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <RedoIcon
              fontSize="large"
              color={canRedo ? "primary" : "secondary"}
            />
          </ListItemIcon>
          <ListItemText sx={{ textAlign: "center", color: "#ffffff" }}>Redo</ListItemText>
        </Stack>
      </Box>
      <Box
        component="div"
        onClick={() => undo()}
        sx={{
          width: "40px",
          position: "fixed",
          top: "85px",
          right: "70px",
          zIndex: "20",
          cursor: "pointer",
        }}
      >
        <Stack>
          <ListItemIcon
            sx={{
              background: "rgba(0,0,0,0.5)",
              minWidth: "40px",
              borderRadius: "100%",
              width: "40px",
              height: "40px",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <UndoIcon
              fontSize="large"
              color={canUndo ? "primary" : "secondary"}
            />
          </ListItemIcon>
          <ListItemText sx={{ textAlign: "center", zIndex: 100000, color: "#ffffff" }}>
            Undo
          </ListItemText>
        </Stack>
      </Box>
      <Box
        onClick={() => changeRoomView(RoomViewType.firstPersonView)}
        component="div"
        sx={{
          position: "fixed",
          bottom: "20px",
          right: "125px",
          cursor: "pointer",
          zIndex: 100,
        }}
      >
        <Stack>
          <ListItemIcon
            sx={{
              background: "rgba(255, 255, 255, 1.0)",
              minWidth: "40px",
              borderRadius: "100%",
              width: "40px",
              height: "40px",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <img
              src={RecenterIcon.src}
              alt=""
              style={{
                opacity: 1.0,
              }}
            />
          </ListItemIcon>
          <ListItemText sx={{ textAlign: "center", color: "#ffffff" }}>
            Re-center
          </ListItemText>
        </Stack>
      </Box>

      <Box
        onClick={() => changeRoomView(RoomViewType.top)}
        component="div"
        sx={{
          position: "fixed",
          bottom: "20px",
          right: "80px",
          cursor: "pointer",
          zIndex: 100,
        }}
      >
        <Stack>
          <ListItemIcon
            sx={{
              background: "rgba(255, 255, 255, 1.0)",
              minWidth: "40px",
              borderRadius: "100%",
              width: "40px",
              height: "40px",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <img
              src={TopIcon.src}
              alt=""
              style={{
                opacity: 1.0,
              }}
            />
          </ListItemIcon>
          <ListItemText sx={{ textAlign: "center", color: "#ffffff" }}>
            Top
          </ListItemText>
        </Stack>
      </Box>

      <Box
        onClick={() => toggleDimensionsMode()}
        component="div"
        sx={{
          position: "fixed",
          bottom: "20px",
          right: "20px",
          cursor: "pointer",
          zIndex: 100,
        }}
      >
        <Stack>
          <ListItemIcon
            sx={{
              background: "rgba(255, 255, 255, 1.0)",
              minWidth: "40px",
              borderRadius: "100%",
              width: "40px",
              height: "40px",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <img
              src={DimensionIcon.src}
              alt=""
              style={{
                opacity: 1.0,
              }}
            />
          </ListItemIcon>
          <ListItemText sx={{ textAlign: "center", color: "#ffffff" }}>
            Dimensions
          </ListItemText>
        </Stack>
      </Box>
    </>
  );
}
export default ClientComponent(ToolsBar);